var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "article",
    [
      _vm.lnAcn
        ? [
            _c("account-box-header", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.openDetail,
                  expression: "openDetail"
                }
              ],
              attrs: { summary: _vm.brifLnAcn }
            }),
            _c("account-box", {
              attrs: { "acn-list": _vm.lnAcn, page: "myAccount" }
            })
          ]
        : [
            _c("div", { staticClass: "empty" }, [
              _vm._m(0),
              _c("strong", { staticClass: "empty-text" }, [
                _vm._v(_vm._s(/*조회 내역이 없습니다.*/ _vm.$t("MCOM-0000015")))
              ])
            ])
          ]
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "empty-img" }, [
      _c("i", { staticClass: "icon icon-opt-no" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }